import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, TextField } from '@material-ui/core';
import { useStyles } from '../login/LoginPage';
import authService from '../../../services/AuthService/AuthService';
import { useSetRecoilState } from 'recoil';
import { alertState } from '../../../recoil-store/recoil-state';
import CircularProgress from "@material-ui/core/CircularProgress";


/**
 * @Description This function lets you return Forget Password page.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function ForgetPassword() {
    const classes = useStyles();
    const { t } = useTranslation();
    const label = 'CONTENT.AUTH-PAGES.';
    const [loading, setLoading] = useState(false);
    const history = useNavigate();
    const setAlert = useSetRecoilState(alertState);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const response = await authService.forgetPassword(e.target.email.value);
        setLoading(false);
        if (!response) {
            setAlert(alert => ({ ...alert, show: true, message: t('GENERAL.NETWORK-ERROR'), severity: 'error' }))
        }
        else {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t('MESSAGES.AUTH-PAGES.FORGOT-PAGE.' + response.message),
                severity: response.status ? 'success' : 'error'
            }))
            // if (response.status) {
            //     setTimeout(() => { history('/login'); }, 6000);
            // }
        }
    };

    return (
        <div className="login-page">
            <form onSubmit={handleSubmit} className="login-container forgot">
                <div className="login-autommate"></div>
                <div className="login-seperator"><div></div><div>{t(label + 'FORGOT-PASSWORD-TITLE')}</div><div></div></div>
                <div className="login-desc">{t(label + 'FORGOT-PASSWORD-SUBTITLE')}</div>
                <div>
                    <div className="login-label">
                        <div>{t(label + 'EMAIL')} *</div>
                        <TextField classes={{ root: classes.text }} variant="outlined" fullWidth name="email" placeholder={t(label + 'FORGOT-PASSWORD-EMAIL-PLACE')} />
                    </div>
                    <div className="login-option">
                        <div></div>
                        <Link to="/login">{t(label + 'BACK-TO-LOGIN')}</Link>
                    </div>
                </div>
                <Button endIcon={loading ? <CircularProgress style={{ color: "#fff" }} size={20} /> : null}
                    style={{ backgroundColor: '#031226', color: '#fff', width: '100%', padding: '9px 0' }}
                    disabled={loading} type="submit">
                    {!loading && <span className="login-signin">{t(label + 'RESET-PASSWORD')}</span>}
                </Button>
            </form>
            <div className="login-right">
                <div>{t(label + 'AUTOMATE')}</div>
                <div>{t(label + 'WITHOUT-CODE')}</div>
                <div>{t(label + 'INTEGRATING')}</div>
            </div>
        </div>
    );
}
export default ForgetPassword;